import { Suspense, lazy } from 'react';
import type { DateRangePickerWrapperProps } from './components/DateRangePickerWrapper';
import type { DateRange, DefinedRange } from './types';

export type { DefinedRange, DateRange };

const DateRangePickerImport = lazy(
  () => import(/* webpackChunkName: "components/daterange-picker/index" */ './components/DateRangePickerWrapper')
);

const DateRangePicker = (props: DateRangePickerWrapperProps) => {
  return (
    <Suspense fallback={'loading...'}>
      <DateRangePickerImport {...props} />
    </Suspense>
  );
};

export { DateRangePicker };
